import produce from 'immer';

const INITIAL_STATE = {
  camerasCount: 0,
  configCount: 0,
  read: false
};

export default (state = INITIAL_STATE, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case '@notificaton/SET_CAMERAS_COUNT':
        draft.camerasCount = action.payload.count;
        break;

      case '@notificaton/SET_CONFIG_COUNT':
        draft.configCount = action.payload.count;
        break;

      case '@notificaton/SET_READ':
        draft.read = action.payload.read;
        break;

      default:
    }
  });
};
